import {Bank} from "../../../../resources/bank"

export type ServiceMessageFormProps = {
	banks: Bank[]
	incoming?: boolean
}

export const messageTypes = {
	"return-request": "Return Request",
	"investigation-request": "Investigation Request",
}

export type MessageType = keyof typeof messageTypes

export enum RequestMessageType {
	ReturnRequestMessage = "returnRequestMessage",
	InvestigationRequestMessage = "investigationRequestMessage",
	InvestigationRequestForIncomingWireMessage = "investigationRequestForIncomingWireMessage",
	ReturnRequestForIncomingWireMessage = "returnRequestForIncomingWireMessage",
}

export type WireRequest = {
	type: typeof RequestMessageType[keyof typeof RequestMessageType]
	attributes: {
		originalMessageDate: string
		originalMessageImad?: string
		originalMessageOmad?: string
		information: string
		testProductionCode: "P"
	}
	relationships: {
		bank: {
			data: {
				type: string
				id: string
			}
		}
	}
}

export type WireResponseAttributes = {
	imad?: string
	omad?: string
	caseId: string
}

export type WireResponse = {
	data: {
		type: string
		attributes: WireResponseAttributes
	}
}
